import styled from 'styled-components'

import type { StyledTextInputProps, StyledPostfixProps } from './types'

export const InputWrapper = styled.label`
  font-family: ${({ theme }) => theme.fonts.mainFont};
  flex-grow: 0;
  flex-shrink: 1;
  flex-basis: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 4px;
`
export const TextInput = styled.input<StyledTextInputProps>`
  font-family: ${({ theme }) => theme.fonts.mainFont};
  color: ${({ readOnly, theme }) =>
    readOnly ? theme.colors.slateGray : theme.colors.sapphireDark};
  border: none;
  padding: 0;
  outline: none;
  width: ${({ $inputWidth }) => $inputWidth};
  font-weight: 400;
  font-size: 16px;
  line-height: 20px;

  ::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  ::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
`

export const Postfix = styled.div<StyledPostfixProps>`
  color: ${({ $readOnly, theme }) =>
    $readOnly ? theme.colors.slateGray : theme.colors.sapphireDark};
  font-family: ${({ theme }) => theme.fonts.mainFont};
  display: block;
  margin-left: 3px;

  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
`
